module.exports = __webpack_public_path__ + "img/wechatQRCode_02.1b43930b.png";